import styled from "styled-components";
import { spacing, color, palette } from "@conserveit/blocks";

export const Wrapper = styled.div`
  display: block;
  position: absolute;
  left: 0;
  border-radius: 4px;
  border: 1px solid ${palette.neutral4};
  height: 250px;
  width: 240px;
  padding-bottom: 50px;
  z-index: 10;
  background: ${color.pureWhite};
  box-shadow: 0 0 10px 0 rgba(55, 64, 71, 0.12),
    0 2px 3px 0 rgba(55, 64, 71, 0.1);
  transform: translate(0, calc(-100% + 20px));
  cursor: default;

  &:before {
    display: inline-block;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 12px;
    bottom: -12px;
    box-sizing: border-box;
    border: 12px solid black;
    border-color: transparent transparent ${color.pureWhite} ${color.pureWhite};
    transform-origin: 50%;
    transform: rotate(-45deg);
    box-shadow: 0 0 10px 0 rgba(55, 64, 71, 0.12),
      0px 3px 3px 1px rgba(55, 64, 71, 0.1);
    z-index: 0;
  }
`;

export const Inner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${color.pureWhite};
`;

export const Content = styled.div`
  position: relative;
  padding: ${spacing.snug} 0 40px;
  height: 200px;
  overflow-y: auto;
  background: ${color.pureWhite};
  z-index: 1;
`;

export const Row = styled.div`
  font-size: 12px;
  line-height: 20px;
  padding: 0 ${spacing.snug};

  h3 {
    margin: 0 0 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  strong {
    font-weight: 600;
  }
`;

export const QuickLink = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  border-top: 1px solid ${color.theme.divider.solid};
  padding: 0 16px;
  background: ${color.pureWhite};
  z-index: 1;

  a {
    font-size: 13px;
    line-height: 38px;
    color: ${color.theme.primaryColor.action.primary};
    border-bottom: 1px dotted ${color.theme.primaryColor.action.primary};
  }
`;

export const PreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid ${color.theme.divider.solid};
  padding: 0 ${spacing.snug};

  h3 {
    display: inline-block;
    margin: 0;
    color: ${palette.neutral7};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

export const UnassociateButton = styled.button.attrs({ type: "button" })`
  && {
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 0;
    border: none;
    outline: 0;
    font-size: 12px;
    color: ${color.theme.semantic.destructive.secondary.foreground};

    &:hover {
      text-decoration: underline;
    }
  }
`;
